/**
 * =====================================================================
 * LEGACY SITE BOOTSTRAP (TRANSITIONAL)
 * =====================================================================
 *
 * This file is a procedural compatibility layer that bootstraps:
 * - Legacy DOMContentLoaded
 *
 *  New features should live in:
 *   - Stimulus controllers
 *   - Vue components
 *   - Shared infrastructure modules
 *
 * This file exists only to be reduced over time during the refactor.
 * Try to avoid adding anything other than quick patches in the legacy block
 * =====================================================================
 */

/* -----------------------------
 * MODERN / SHARED BOOTSTRAP
 * -----------------------------

/**
 * Stimulus bootstrap (Symfony UX / Vite convention)
 * This file MUST remain framework-only and JS.
 */
import './bootstrap.js';

/*  Modern globals or utilites */
import '@shared/script/inputModality';

/* -----------------------------
 * LEGACY DEPENDENCIES
 * ----------------------------- */
import initBelgianAddresses from './belgian_addresses';
import basMaxTickets from './bas_max_tickets';
import checkDeliveryMethods from './check_deliverymethods';
import initAbandondedCartBanner from './abandoned_cart_banner';
import initCart from './cart';
import initCinemaPlanner from './cinema_planner';
import initCoursesAgeFilter from './courses_age_filter';
import initFilterResets from './filter_resets';
import initFilters from './filters';
import initFormCheckCancellation from './formcheck_cancellation';
import initFormCheckCheckboxes from './formcheck_checkboxes';
import initFormCheckEmail from './formcheck_email';
import initFormCheckPassword from './formcheck_password';
import initFormCheckValidationMsg from './formcheck_validationmsg';
import initFormDatePicker from './form_datepicker';
import initGlobal from './_index';
import initIBANValidation from './iban_check';
import initLoginPassword from './login_password';
import initOptins from './optins';
import initOrderAgreement from './order_agreement';
import initOrderItems from './order_items';
import initOrderPhoneInput from './order_phonenumber_input';
import initOrderOptins from './order_optins';
import initPopovers from './popovers';
import initPreventLeave from './prevent_leave';
import initPricePromotion from './price_promotion';
import initRecaptcha from './recaptcha';
import initSidebarFilters from './filters_sidebar';
import initSimpleFilters from './filters_simple';
import initSpektrix from './spektrix';
import './Components/view_from_seats';
import initSubmitLockout from './submit_lockout';
import initTicketListCancellation from './ticketlist_cancellation';
import initTicketListExtras from './ticketlist_extras';
import initTRFilters from './filters_TR';
import initVoucherPayment from './voucher_payment';
import initCancellation from './cancellation';
import initBasMembership from './bas_membership';
import { fillExtrasSelect } from './bas_extras';
import { initUserDetailsForm } from './formcheck_gegevensForm';

import initComponents from './Components/index';
import initParts from './Parts/index';

/* -----------------------------
 * LEGACY DOM READY INITIALISATION
 * ----------------------------- */
document.addEventListener('DOMContentLoaded', async function() {
    basMaxTickets();
    checkDeliveryMethods();
    initAbandondedCartBanner();
    initBasMembership();
    initBelgianAddresses();
    initCart();
    initCinemaPlanner();
    initComponents();
    initCoursesAgeFilter();
    initFilterResets();
    initFilters();
    initFormCheckCancellation();
    initFormCheckCheckboxes();
    initFormCheckEmail();
    initFormCheckPassword();
    initFormCheckValidationMsg();
    initFormDatePicker();
    initGlobal();
    initIBANValidation();
    initLoginPassword();
    initOptins();
    initOrderAgreement();
    initOrderItems();
    initOrderPhoneInput();
    initParts();
    initPopovers();
    initPreventLeave();
    initPricePromotion();
    initRecaptcha();
    initSidebarFilters();
    initSimpleFilters();
    initSpektrix();
    initSubmitLockout();
    initTicketListCancellation();
    initTicketListExtras();
    initTRFilters();
    initUserDetailsForm();
    initOrderOptins();
    initVoucherPayment();
    initCancellation();

    // Wrapping legacy jQuery handlers here solves some import bugs
    // ignore ts error, no point setting up types for old jQuery code
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    $('#ticketsForm-kaartsoorten select').change(function() {
        fillExtrasSelect();
    });

});
